export default "__VITE_ASSET__CPdADPCh__"